import "./HplcSolventRecoveryResolve.module.css";
import Header from "@/reusable_sections/Header";
import SolventHero from "./sections/SolventHero";
import HiddenCost from "./sections/HiddenCost";
import ProcessWorkflow from "./sections/ProcessWorkflow";
import SustainabilityImpact from "./sections/SustainabilityImpact";
import OnboardingPathway from "./sections/OnboardingPathway";
import Offerings from "./sections/Offerings";
import Consultation from "./sections/Consultation";
import RelatedHubs from "./sections/RelatedHubs";
import Resources from "./sections/Resources";
import Footer from "@/reusable_sections/Footer";
export default function HplcSolventRecoveryResolvePage() {
  return <div>
      <Header />
      <SolventHero />
      <HiddenCost />
      <ProcessWorkflow />
      <SustainabilityImpact />
      <OnboardingPathway />
      <Offerings />
      <RelatedHubs />
      <Resources />
      <Consultation />
      <Footer />
    </div>;
}